import script from "./SectionRequiredCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionRequiredCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./SectionRequiredCalendar.vue?vue&type=style&index=0&id=37691522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37691522"]])

export default __exports__